// FILECONTENT_START src/common/AppRoot.tsx
import { ThemeOptions } from "@mui/material/styles";
import { ReactNode } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// @ts-ignore
import { PersistGate } from "redux-persist/integration/react";
import "text-security/text-security.css";
import GlobalMessaging from "./components/GlobalMessaging";
import { NavigationContext } from "./components/Navigation";
import { AppThemeProvider } from "./modules/theme";

//const hist = createBrowserHistory();

interface AppRootProps {
  children: ReactNode;
  createTheme: (baseTheme: ThemeOptions) => any;
  store: any;
  persistor: any;
}
export default function AppRoot({
  children,
  createTheme,
  store,
  persistor,
}: AppRootProps) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppThemeProvider createTheme={createTheme}>
          <BrowserRouter>
            <NavigationContext>{children}</NavigationContext>
          </BrowserRouter>
          <GlobalMessaging />
        </AppThemeProvider>
      </PersistGate>
    </Provider>
  );
}

// FILECONTENT_END src/common/AppRoot.tsx
